// SEO 替没有标题的iframe添加标题
// 等待文档完全加载
document.addEventListener('DOMContentLoaded', function() {
  // 获取所有 iframe 元素
  const iframes = document.querySelectorAll('iframe');
  
  iframes.forEach(function(iframe) {
    // 判断 iframe 是否已经有 title 属性
    if (!iframe.hasAttribute('title')) {
      // 如果没有 title 属性，使用 id 或 class 或默认值 'iframe'
      const title = iframe.id || iframe.className || 'iframe';
      iframe.setAttribute('title', title);
    }
  });
});
